import React from "react";
import { Redirect } from "react-router-dom";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";

import AdsPage from "../pages/Ads";
import CustomersPage from "../pages/Users/Customers";
import TechniciansPage from "../pages/Users/Technicians";
import NotifyUsersPage from "../pages/Users/NotifyUsers";
import SettingsPage from "../pages/Profile/Settings";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import CategoriesPage from "../pages/Services/Categories";
import ServicesPage from "../pages/Services/Services";
import GovernoratesPage from "../pages/Places/Governorates";
import CitiesPage from "../pages/Places/Cities";
import ComplainsPage from "../pages/ComplainsAndSuggestions/Complains";
import DashboardV2Page from "../pages/Dashboard/DashboardV2";
import OrdersPage from "../pages/Orders/Orders";
import PrivacyPolicyPage from "../pages/PrivacyPolicy";
import PrivacyPolicyPublicPage from "../pages/Public/privacy-policy/PrivacyPolicyPublicPage";
import ContactUsPage from "../pages/Public/contact/ContactUsPage";
import AccountDeleteRequestPage from "../pages/Public/account-delete-request/AccountDeleteRequest";

const authProtectedRoutes = [
  { path: "/dashboard", component: DashboardV2Page },
  { path: "/users/customers", component: CustomersPage },
  { path: "/users/technicians", component: TechniciansPage },
  { path: "/users/notify", component: NotifyUsersPage },
  { path: "/settings", component: SettingsPage },
  {
    path: "/services/categories",
    component: CategoriesPage,
  },
  {
    path: "/services/services",
    component: ServicesPage,
  },
  {
    path: "/places/governorates",
    component: GovernoratesPage,
  },
  {
    path: "/places/cities",
    component: CitiesPage,
  },
  {
    path: "/ads",
    component: AdsPage,
  },
  {
    path: "/complains",
    component: ComplainsPage,
  },
  {
    path: "/orders",
    component: OrdersPage,
  },
  {
    path: "/privacy-policies",
    component: PrivacyPolicyPage,
  },
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/privacy-policy", component: PrivacyPolicyPublicPage },
  { path: "/privacy-policy/:lang", component: PrivacyPolicyPublicPage },
  { path: "/support", component: ContactUsPage },
  { path: "/delete-data-request", component: AccountDeleteRequestPage },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/reset-password/:token", component: ResetPasswordPage },
];

export { authProtectedRoutes, publicRoutes };
